import { Close } from '@mui/icons-material';
import { Divider, IconButton, Stack } from '@mui/material';
import React from 'react';

export default function NotificationCenterTab({
  header,
  body,
  footer,
  onClose,
}) {
  return (
    <>
      <Stack direction="row" alignItems="center" gap={2.25} p={3}>
        {header}
        <IconButton onClick={onClose} size="small">
          <Close />
        </IconButton>
      </Stack>
      <Stack
        flexGrow={1}
        minWidth="350px"
        maxWidth="420px"
        width={{ sm: '420px' }}
        overflow="auto"
        divider={<Divider sx={{ mx: 1 }} />}
      >
        {body}
      </Stack>
      {footer}
    </>
  );
}
